import {FormEvent, useState} from "react";
import {validateGoogleDocUrl} from "../utils/utils";
import {API_URL, DocType} from "../constants/constants";
import {IParsedAdditional, IParsedInvoice} from "../types/types";
import {toast} from "react-toastify";
import {authFetch} from "../services/api";

const DOC_LABELS: Record<DocType, string> = {
    [DocType.ADDITIONAL]: 'Получить данные из приложения',
    [DocType.INVOICE]: 'Получить данные из акта',
};

export const DocForm = ({onSuccess, docContext}: {
    onSuccess: (data: IParsedAdditional | IParsedInvoice) => void;
    docContext: DocType;
}) => {
    const [url, setUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');


    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        const trimmedUrl = url.trim();

        if (!validateGoogleDocUrl(trimmedUrl)) {
            setError('Введите корректную ссылку на Google документ');
            return;
        }

        setLoading(true);

        try {
            const params = new URLSearchParams({type: docContext, googleDocUrl: trimmedUrl});
            const response = await authFetch(`${API_URL}/documents-status?${params}`);


            const data = await response.json();

            if (!response.ok) throw new Error(data.message)
            else setError('')

            toast.success('Данные успешно запрошены!');

            onSuccess(data);
        } catch (e) {
            console.error('Ошибка при отправке формы:', e);
            setError(`${e}`);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="container">
            <div className="form-wrapper">
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="docUrl" className="form-label">
                            {DOC_LABELS[docContext]}
                        </label>

                        <input
                            type="url"
                            id="docUrl"
                            className='form-input'
                            placeholder="https://docs.google.com/document/d/..."
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            disabled={loading}
                            required
                        />
                        <div className="helper-text">
                            Вставьте ссылку на Google документ
                        </div>
                        <div className="error-message">
                            {error}
                        </div>
                    </div>

                    <button
                        type="submit"
                        className={`button ${loading ? 'loading' : ''}`}
                        disabled={loading}
                    >
                        {!loading && 'Отправить'}
                    </button>
                </form>

            </div>
        </div>
    );
}
